// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  softwareVersion: 57,
  production: false,
  isolation: "__",
  itemsTimeoutInSeconds: 3600,
  sessionTimeout: 1113600,
  subscribeDashboardSummaryOrderStatus: false,
  subscribeDashboardCompletedOrders: false,
  isEnableHomePage: true,
  apiDomain: 'api-preprd.khmum.com',
  imageDomain: 'preprd-vr.khmum.com',
  adminEmail: 'versita.store.vr.prd@gmail.com',
  adminPassword: 'qlqixetwbdsugrtu',
  encryptKey: '!Zw8q4ZNc)wuZRDz*LC%8BE?Fr>PK_G:',
  isPhoneEnable: true,
  isEmailEnable: true,
  firebase: {
    "apiKey": "AIzaSyC_D29gGH73LEn79TXgoxfQMqY3mjC6tHM",
    "appId": "1:978946892401:web:f8465e581d7d5eee52b1d0",
    "authDomain": "preprd-vr.khmum.com",
    "databaseURL": "https://versita-store-vr-preprd.firebaseio.com",
    "messagingSenderId": "978946892401",
    "projectId": "versita-store-vr-preprd",
    "storageBucket": "versita-store-vr-preprd.appspot.com"
  }
};

/*
firebase: {
  // firebase config *** vr preprd

    "apiKey": "AIzaSyC_D29gGH73LEn79TXgoxfQMqY3mjC6tHM",
    "appId": "1:978946892401:web:f8465e581d7d5eee52b1d0",
    "authDomain": "preprd-vr.khmum.com",
    "databaseURL": "https://versita-store-vr-preprd.firebaseio.com",
    "messagingSenderId": "978946892401",
    "projectId": "versita-store-vr-preprd",
    "storageBucket": "versita-store-vr-preprd.appspot.com"


    // firebase config *** vr stg

    apiKey: "AIzaSyD9PlDBAylPZdClSQpHdvyhRcF-TCmie98",
    authDomain: "stg-vr.khmum.com",
    databaseURL: "https://versita-store-vr-stg.firebaseio.com",
    projectId: "versita-store-vr-stg",
    storageBucket: "versita-store-vr-stg.appspot.com",
    messagingSenderId: "403943987265",
    appId: "1:403943987265:web:32f728f34ec7f344a44ec0"

    // firebase config *** vr dev
    apiKey: "AIzaSyBY87f0bRQ9SMefZ1gX4m-pn-ZL7NgY7pg",
    authDomain: "versita-store-vr-dev.firebaseapp.com",
    databaseURL: "https://versita-store-vr-dev.firebaseio.com",
    projectId: "versita-store-vr-dev",
    storageBucket: "versita-store-vr-dev.appspot.com",
    messagingSenderId: "790463039904",
    appId: "1:790463039904:web:8ab27be85a5cab12ebfcc5"
}*/
